import moment from 'moment';
import { enqueueUpdate } from '../../helpers/request_queue';

export const updateStartEndDate = (startDate, endDate) => {
  return (dispatch, getState) => {
    let url = getState().getIn(['timelineConfig', 'bookmarkPath']);
    const params = {};
    const reactClientId = window.reactiveClientId();

    // we want the json format, no need to get a js script and evaluate it
    // in fact, getting the js format will likely call $('#modal-window').modal('hide');
    // which is definitely not what we want if the saved views modal (for example) is open
    if (url.endsWith('.js')) {
      url = url.slice(0, -3);
    }
    url = url + '.json';

    if (startDate) {
      params.configuration_timeline_start_date = startDate.toISOString();
    }

    if (endDate) {
      params.configuration_timeline_end_date = endDate.toISOString();
    }

    enqueueUpdate({
      url,
      data: {
        bookmarks_custom_pivot: params,
        reactive_client_id: reactClientId,
      },
    });
  };
};

export const setDates = dates => {
  return {
    type: 'SET_DATES',
    payload: { dates },
  };
};

export const resetDates = () => {
  return {
    type: 'RESET_DATES',
    payload: {},
  };
};

export const changeMinDate = date => {
  return (dispatch, getState) => {
    const state = getState();
    const timelineConfig = state.get('timelineConfig');
    const dateRange = state.get('dateRange');

    if (date) {
      date = moment.utc(date);
    }

    if (!date || date.isAfter(dateRange.get('maxDate'))) {
      date = dateRange.get('automaticMinDate');
    }

    const params = { configuration_min_date: date.toISOString() };
    updateTimelineConfig(timelineConfig, params);

    dispatch({
      type: 'CHANGE_MIN_DATE',
      payload: date,
    });
  };
};

export const changeMaxDate = date => {
  return (dispatch, getState) => {
    const state = getState();
    const timelineConfig = state.get('timelineConfig');
    const dateRange = state.get('dateRange');

    if (date) {
      date = moment.utc(date);
    }

    if (!date || date.isBefore(dateRange.get('minDate'))) {
      date = dateRange.get('automaticMaxDate');
    }

    const params = { configuration_max_date: date.toISOString() };
    updateTimelineConfig(timelineConfig, params);

    dispatch({
      type: 'CHANGE_MAX_DATE',
      payload: date,
    });
  };
};

export const changeTimeScale = timeScale => {
  return (dispatch, getState) => {
    const timelineConfig = getState().get('timelineConfig');

    if (!timeScale || timeScale === 'auto') {
      timeScale = null;
    }

    const params = { configuration_time_scale: timeScale };
    updateTimelineConfig(timelineConfig, params);

    dispatch({
      type: 'CHANGE_TIME_SCALE',
      payload: timeScale,
    });
  };
};

export const changeZoom = zoom => {
  return (dispatch, getState) => {
    const timelineConfig = getState().get('timelineConfig');

    const params = { configuration_zoom: zoom };
    updateTimelineConfig(timelineConfig, params);

    dispatch({
      type: 'CHANGE_ZOOM',
      payload: zoom,
    });
  };
};

const updateTimelineConfig = (timelineConfig, params) => {
  enqueueUpdate({
    url: timelineConfig.bookmarkPath,
    data: { bookmarks_custom_pivot: params },
  });
};
